// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteAccount-pageTitle-YkX78 {
    font-size: 22px;
    font-weight: 700;
    color: #1F2733;
    margin: 0 0 18px;
    font-family: 'Poppins', sans-serif;
}

.DeleteAccount-warningCard-PTuzG {
    background: #FFF6F4;
    border: 1px solid #F3C9C2;
    border-radius: 14px;
    padding: 24px;
    max-width: 640px;
}

.DeleteAccount-warningTitle-St2XO {
    font-size: 18px;
    font-weight: 700;
    color: #D32F2F;
    margin: 0 0 10px;
}

.DeleteAccount-warningText-LJ7MF {
    font-size: 15px;
    line-height: 1.6;
    color: #555;
    margin: 0 0 20px;
}

.DeleteAccount-btnRow-Gx18U {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.DeleteAccount-deleteBtn-aZt7x {
    width: auto;
    min-width: 220px;
    background: #D32F2F;
    border-color: #D32F2F;
}
`, "",{"version":3,"sources":["webpack://./src/routes/deleteAccount/DeleteAccount.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB","sourcesContent":[".pageTitle {\n    font-size: 22px;\n    font-weight: 700;\n    color: #1F2733;\n    margin: 0 0 18px;\n    font-family: 'Poppins', sans-serif;\n}\n\n.warningCard {\n    background: #FFF6F4;\n    border: 1px solid #F3C9C2;\n    border-radius: 14px;\n    padding: 24px;\n    max-width: 640px;\n}\n\n.warningTitle {\n    font-size: 18px;\n    font-weight: 700;\n    color: #D32F2F;\n    margin: 0 0 10px;\n}\n\n.warningText {\n    font-size: 15px;\n    line-height: 1.6;\n    color: #555;\n    margin: 0 0 20px;\n}\n\n.btnRow {\n    display: flex;\n}\n\n.deleteBtn {\n    width: auto;\n    min-width: 220px;\n    background: #D32F2F;\n    border-color: #D32F2F;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageTitle": `DeleteAccount-pageTitle-YkX78`,
	"warningCard": `DeleteAccount-warningCard-PTuzG`,
	"warningTitle": `DeleteAccount-warningTitle-St2XO`,
	"warningText": `DeleteAccount-warningText-LJ7MF`,
	"btnRow": `DeleteAccount-btnRow-Gx18U`,
	"deleteBtn": `DeleteAccount-deleteBtn-aZt7x`
};
module.exports = ___CSS_LOADER_EXPORT___;
